var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcreteMixer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H14C14 15.5523 14.4477 16 15 16V15ZM27 15C27 21.6274 21.6274 27 15 27V29C22.732 29 29 22.732 29 15H27ZM15 27C8.37258 27 3 21.6274 3 15H1C1 22.732 7.26801 29 15 29V27ZM3 15C3 8.37258 8.37258 3 15 3V1C7.26801 1 1 7.26801 1 15H3ZM15 3C21.6274 3 27 8.37258 27 15H29C29 7.26801 22.732 1 15 1V3ZM28 14H15V16H28V14ZM14 2V15H16V2H14Z",
    fill: "#FF6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcreteMixer);
export default __webpack_public_path__ + "static/media/concrete-mixer.923a3c67eb9210e1822cbb0f5792eb3f.svg";
export { ForwardRef as ReactComponent };